/* eslint-disable no-unused-vars */
import React, { useState, useContext } from 'react';
import { isEmpty } from 'lodash';
import parse from 'html-react-parser';
import { DWTCContext } from '../../utils/context';
import {
  AwardsMobileWrapper,
  AwardsMobileContainer,
  AwardsMobileHeader,
  AwardsMobileBody,
  AwardsMobileTabHeaderWrapper,
  AwardsMobileTab,
  SliderContenSection,
  SliderContentWrapper,
  OurAwardDescription,
} from '../styles/OurAwards.styled';

export default function AwardsMobile({ data, dir, id }) {
  const [activeTab, setActiveTab] = useState(0);
  const langDir = dir === 'ar' ? 'rtl' : 'ltr';

  return (
    <AwardsMobileWrapper id={id} className="smoothed">
      <AwardsMobileContainer>
        <AwardsMobileHeader>
          <h2 dir={dir}>{data.title}</h2>
        </AwardsMobileHeader>
        <AwardsMobileBody>
          <AwardsMobileTabHeaderWrapper>
            {isEmpty(data.awardsList) ||
              data.awardsList.map(({ content }, index) => (
                <AwardsMobileTab
                  key={index}
                  dir={dir}
                  onClick={() => setActiveTab(index)}
                  active={index === activeTab}
                  className={`${index === activeTab ? 'active-tab' : ''}`}
                >
                  {content.title}
                </AwardsMobileTab>
              ))}
          </AwardsMobileTabHeaderWrapper>
          {!isEmpty(data.awardsList) &&
            data.awardsList.map((item, index1) => (
              <SliderContenSection key={index1}
              className={`${activeTab === index1 ? 'active-tab' : 'mobile-tab'}`}
              >
                <SliderContentWrapper>
                  <h3>{item.content.header}</h3>
                  <OurAwardDescription>{parse(item.content.bulletList)}</OurAwardDescription>
                </SliderContentWrapper>
              </SliderContenSection>
            ))}
        </AwardsMobileBody>
      </AwardsMobileContainer>
    </AwardsMobileWrapper>
  );
}
